import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'
import { PublicInterceptor } from '../../../Base/interceptors/PublicInterceptor';
import { PublicInterceptorPR } from '../../../Base/interceptors/PublicInterceptorsPR';

export const getPersonal = async () => {
    const response = await PrivateInterceptor('Payrolls/personal', 'GET');
    return response
}

export const getPersonalById = async (id) => {
    const response = await PrivateInterceptor(`Payrolls/personal/${id}`, 'GET');
    return response
}

export const getPersonalToken = async (token) => {
    const result = await PublicInterceptor(`Payrolls/personal`, 'GET', {}, token);
    return result;
}
export const getPersonalSinToken = async () => {
    const result = await PublicInterceptorPR(`Payrolls/personal`, 'POST');
    return result;
}

// OBTENER PERSONAL POR ID
export const getPersonalByIdToken = async (id, token) => {
    const result = await PublicInterceptorPR(`Personal/${id}`, 'GET', null, token);
    return result;
}

// GET DETALLES POR IdQR
export const getDetallesPersonalPorIdQR = async (IdQR) => {
    const response = await PrivateInterceptor(`Payrolls/personal/detalles/${IdQR}`, 'GET');
    return response;
};